<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/TWqJip/tc-custom/9781488081972.jpg?1728327020079" alt="This image is the cover for the book Summer Villa"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Summer Villa
      </h1>
      <p class="bookDescription body article font2">
        <b>A trip to a villa on Italy’s Amalfi Coast alters the course of three very different women’s lives in this #1 international bestseller about friendship.</b><br/><br/>Villa Dolce Vita, a rambling stone house on the Amalfi Coast, sits high above the Gulf of Naples amid dappled lemon groves and fragrant, tumbling bougainvillea. Kim, Colette and Annie all came to the villa in need of escape and in the process forged an unlikely friendship.<br/><br/>Now, years later, Kim has transformed the crumbling house into a luxury retreat and has invited her friends back for the summer to celebrate.<br/><br/>But as friendships are rekindled under the Italian sun, secrets buried in the past will come to light, and not everyone is happy that the three friends are reuniting . . . Each woman will have things to face up to if they are all to find true happiness and fully embrace the sweet life.<br/><br/>An epic summer read about food, friendship and the magic of Italy, perfect for fans of Mary Kay Andrews and Susan Mallery.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Melissa Hill
      </h2>
      
      <p class="authorDescription body article">Melissa Hill lives in Ireland with her husband and daughter. A <I>USA TODAY</I> and #1 <I>Irish Times</I> bestselling author, her books have been translated into twenty-five different languages.One of her titles has been optioned for a movie by a major Hollywood studio, and another is currently in development for television. &#160; Visit her website at www.melissahill.ie or contact her on Twitter, @melissahillbks, or melissahillbooks on Facebook and Instagram.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4232a237